module.exports = __webpack_public_path__ + "static/media/Curiosidades-Premio-Ebit-h.619f2332.619f2332.png";